module.exports = __WEBPACK_EXTERNAL_MODULE_38__;


//////////////////
// WEBPACK FOOTER
// external "esri/widgets/Legend"
// module id = 38
// module chunks = 0